import React from 'react';

interface DocumentButtonsProps {
  onGenerateMinutes: () => void;
}

const DocumentButtons: React.FC<DocumentButtonsProps> = ({ onGenerateMinutes }) => {
  return (
    <>
      <div className="panel-section" id="ai-document-section">
        <div className="section-title">
          <span className="section-icon material-symbols-outlined">description</span>
          AIドキュメント作成
        </div>
        <div className="document-buttons">
          <button className="doc-button" onClick={onGenerateMinutes}>
            <div className="doc-info">
              <div className="doc-title">議事録</div>
              <div className="doc-desc">ミーティングの内容をまとめます</div>
            </div>
            <div className="doc-icon color-1">
              <span className="material-symbols-outlined">description</span>
            </div>
          </button>
          <button className="doc-button" disabled>
            <div className="doc-info">
              <div className="doc-title">提案書</div>
              <div className="doc-desc">プロジェクト提案を作成します</div>
            </div>
            <div className="doc-icon color-3">
              <span className="material-symbols-outlined">lightbulb</span>
            </div>
          </button>
          <button className="doc-button" disabled>
            <div className="doc-info">
              <div className="doc-title">見積書</div>
              <div className="doc-desc">コストの見積もりを生成します</div>
            </div>
            <div className="doc-icon color-2">
              <span className="material-symbols-outlined">payments</span>
            </div>
          </button>
          <button className="doc-button" disabled>
            <div className="doc-info">
              <div className="doc-title">レポート</div>
              <div className="doc-desc">分析レポートを作成します</div>
            </div>
            <div className="doc-icon color-5">
              <span className="material-symbols-outlined">bar_chart</span>
            </div>
          </button>
        </div>
      </div>

      <div className="panel-options">
        <button
          className="download-minutes-button"
          id="download-minutes-button"
          onClick={onGenerateMinutes}
        >
          <span className="material-symbols-outlined">download</span>
          議事録ダウンロード
        </button>
      </div>
    </>
  );
};

export default DocumentButtons;
